import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext, useController } from 'react-hook-form';
import { AzElRangeGA2 } from 'common/utils/constants';
import { getDefaultHeatmapRange } from 'common/utils/helpers';
import RasterHeatmap from 'components/features/RasterHeatmap/RasterHeatmap';
import styles from './BeamSelectionControl.module.css';

const range = getDefaultHeatmapRange('ga2');

function BeamSelectionControl({ name, label }) {
  const deviceId = useSelector((state) => state.data.commissioningGA2.deviceId);
  const rasterData = useSelector((state) => state.data.commissioningGA2.rasterData);
  const acqData = useSelector((state) => state.data.commissioningGA2.acqInfo);
  const { setError } = useFormContext();
  const azimuthController = useController({ name: `${name}.azimuth` });
  const elevationController = useController({ name: `${name}.elevation` });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [customValue, setCustomValue] = useState({});

  const handleSelect = (index) => {
    setSelectedIndex(index);

    if(index === 4) return;
    const { az, el } = index <= rasterData.beamrank.length ? rasterData.beamrank[index - 1] : customValue;

    azimuthController.field.onChange(az);
    elevationController.field.onChange(el);
  };

  const handleChange = (value) => {
    let azChanged = false;
    let elChanged = false;

    setCustomValue((prevValue) => {
      azChanged = prevValue.az !== value.az;
      elChanged = prevValue.el !== value.el;

      return value;
    });

    const { az, el } = value;

    if (azChanged) {
      azimuthController.field.onChange(az);
    }

    if (elChanged) {
      elevationController.field.onChange(el);
    }
  };

  const handleError = (errors) => {
    if (errors.az) {
      setError(`${name}.azimuth`, {
        type: 'manual',
        message: errors.az
      });
    }
    if (errors.el) {
      setError(`${name}.elevation`, {
        type: 'manual',
        message: errors.el
      });
    }
  };

  return (
    <div className={styles.root}>
      <h4 className={styles.label}>{label}</h4>
      <RasterHeatmap
        config={AzElRangeGA2}
        isGa2={true}
        range={range}
        id={deviceId}
        className={styles.input}
        azElInputError={{
          az: azimuthController.fieldState.error?.message,
          el: elevationController.fieldState.error?.message
        }}
        setAzElInputError={handleError}
        selectedBeamRankIndex={selectedIndex}
        setSelectedBeamRankIndex={handleSelect}
        customAzEl={customValue}
        setCustomAzEl={handleChange}
        acqData={acqData}
        heatmap={rasterData}
        beamrank={rasterData.beamrank}
      />
    </div>
  );
}

export default BeamSelectionControl;
